import { useState, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

type ReactQueryProviderProps = {
  children: ReactNode;
};

const getQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        throwOnError: false,
      },
      mutations: {
        retry: false,
        throwOnError: false,
      },
    },
  });

export const ReactQueryProvider = ({ children }: ReactQueryProviderProps) => {
  const [queryClient] = useState(() => {
    const client = getQueryClient();

    // Expose for TanStack Query DevTools Chrome extension.
    // https://tanstack.com/query/v5/docs/framework/react/devtools
    if (import.meta.env.VITE_DEPLOY_ENV !== 'prod') {
      // eslint-disable-next-line no-underscore-dangle -- name is prescribed by TanStack
      window.__TANSTACK_QUERY_CLIENT__ = client;
    }

    return client;
  });

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
